// extracted by css-extract-rspack-plugin
export default {"text":"IiwSx","link":"WrVjG"};